import React from 'react';
import ISRMainPage from '../Pages/ISRMainPage';

const ISRMainProvider = (props:any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ISRMainPage isrName={params?.name} isrId={params?.id} />
        </React.Fragment>
    );
}

export default ISRMainProvider;